module.exports = __webpack_public_path__ + "static/media/Kalaallit_2026_Logo.90d89ce2.png";